import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/app");
        } catch (err) {
            setError(errMsg(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell
            title="Bienvenido de vuelta"
            subtitle="Entra y sigue con tu ruta donde la dejaste."
            footer={<>¿Aún no tienes cuenta? <Link to="/registro" className="font-semibold text-nm-accent" data-testid="go-register">Créala gratis</Link></>}
        >
            <form onSubmit={submit} className="space-y-4" data-testid="login-form">
                <div className="space-y-1.5">
                    <Label htmlFor="email">Correo</Label>
                    <Input id="email" type="email" autoComplete="email" data-testid="login-email"
                        value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.com" required />
                </div>
                <div className="space-y-1.5">
                    <div className="flex items-center justify-between">
                        <Label htmlFor="password">Contraseña</Label>
                        <Link to="/recuperar" className="text-xs text-nm-accent" data-testid="go-forgot">¿La olvidaste?</Link>
                    </div>
                    <Input id="password" type="password" autoComplete="current-password" data-testid="login-password"
                        value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Tu contraseña" required />
                </div>
                {error && <p className="rounded-lg bg-nm-accent-soft px-3 py-2 text-sm text-nm-accent" data-testid="login-error">{error}</p>}
                <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
                    {loading ? "Entrando..." : "Entrar"}
                </Button>
            </form>
        </AuthShell>
    );
}
